import { TimezoneDto } from "generated/CoreApi_v1";
import ResourceUtils from "lib/ResourceUtils";

/**
 * Utilitários de Timezone.
 */
export default class TzUtils {

    /**
     * Fuso Horário do Navegador.
     * @returns
     */
    static browserTimezone() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    /**
     * Todos os Fusos Horários do sistema.
     * @returns
     */
    static getAllTimezones(): TimezoneDto[] {
        return window.timezones.sort((a: TimezoneDto, b: TimezoneDto) => a.offset - b.offset);
    }

    /** Retorna o Fuso Horário do Sistema baseado no Fuso Horário do Navegador */
    static get localTimezone() {
        const offset = new Date().getTimezoneOffset() * -1;
        return window.timezones.find(p => p.timezone_id == this.browserTimezone()) ?? window.timezones.find(p => p.offset == offset);
    }

    /**
     * Nome do Fuso Horário do Sistema, baseado no Fuso Horário do Navegador , conforme localização.
     * @param locale
     * @returns
     */
    static localTimezoneName(locale: string): string {
        return ResourceUtils.findName(this.localTimezone?.nameR ?? [], locale, "pt-BR") ?? this.getTimezoneShortName(Intl.DateTimeFormat().resolvedOptions().timeZone);
    }

    /**
     * Nome do Fuso Horário do Sistema, baseado no Fuso Horário do Navegador , conforme localização.
     * @param locale
     * @returns
     */
    static getTimezoneName(timezone: string, locale: string): string {
        const tz = window.timezones.find(p => p.timezoneId == timezone);
        return tz == null ? timezone : ResourceUtils.findName(tz.nameR ?? [], locale, "pt-BR") ?? timezone;
    }

    /**
     * Nome do Fusco Horário do Sistema no formato GMT-XXX
     * @param timezone
     * @returns
     */
    static getTimezoneShortName(timezone: string | null): string {
        if (timezone == null) return "";
        return window.timezones.find(p => p.timezoneId == timezone)?.shortName ?? timezone;
    }

    /**
     * Transforma uma Data no Fuso Horário especificado em uma Data em UTC .
     * @param date
     * @param timezoneId
     * @returns
     */
    static applyTimezoneOffsetToUtc(date: Date | null, timezoneId: string) {
        if (date === null) return date;
        if (this.browserTimezone() == timezoneId) return date;
        return new Date(date.getTime() - date.getTimezoneUtcOffset(timezoneId) + date.getTimezoneUtcOffset(Intl.DateTimeFormat().resolvedOptions().timeZone));
    }

    /**
     * Transforma uma data em UTC em uma Data no Fuso Horário especificado.
     * @param date
     * @param timezoneId
     * @returns
     */
    static applyTimezoneOffsetFromUtc(date: Date | null, timezoneId: string) {
        if (date === null) return date;

        if (this.browserTimezone() == timezoneId) return date;
        return new Date(date.getTime() + date.getTimezoneUtcOffset(timezoneId) - date.getTimezoneUtcOffset(Intl.DateTimeFormat().resolvedOptions().timeZone));
    }
}
